module.exports = __webpack_public_path__ + "img/order_background.7de0c4c8.png";